// extracted by mini-css-extract-plugin
module.exports = {"cardImg":"testimonial-module--cardImg--1Se_Q","CardStyle":"testimonial-module--CardStyle--1D6oV","CardOutline":"testimonial-module--CardOutline--2LZI8"};